<template>
    <div class="product-body">
        <div class="product-body__title" v-if="mobile">
            <h4 v-if="product?.name">{{ decodeHtmlEntities(product.name) }}</h4>
        </div>
        <div class="product-body__filters" v-if="tablet || mobile" ref="filtersRef">
            <div class="product-body__filters-item tabs" v-if="!isOnlineGame">
                <CustomSelect
                    v-model="activePlatformTabId"
                    :hasIconsMask="true"
                    :options="productTabSelect()"
                    :selectId="'direct-top-up-regions'" 
                    @update:modelValue="changeTab()"
                />
            </div>
            <div class="product-body__filters-item" v-else
                v-for="filter in filters.filters"
                v-show="shouldShowFilter(filter.name)"
                :key="filter.name">
                <CustomSelect
                    v-model="formData[filter.name]"
                    :options="productFilterSelect(filter.options)"
                    :selectId="filter.name"
                    :hasSearch="filter.name === 'filter[game_server]'" 
                    @update:modelValue="changeFilters(filter.name)"
                />
                <div class="product-body__filters-item-img" :class="filter.name">
                    <svg v-if="shouldShowFilter(filter.name)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.5878 10.1729H7.83566C7.73537 10.1729 7.65332 10.2549 7.65332 10.3552V19.5176C7.65332 19.6179 7.73537 19.6999 7.83566 19.6999H16.5878C16.6881 19.6999 16.7701 19.6179 16.7701 19.5176V10.3552C16.7701 10.2549 16.6881 10.1729 16.5878 10.1729ZM9.11201 11.6315H15.3114V14.2982H9.11201V11.6315ZM15.3114 18.2412H9.11201V15.5746H15.3114V18.2412Z" fill="#9D9D9D"/>
                        <path d="M10.2061 17.0559C10.2061 17.2493 10.2829 17.4348 10.4197 17.5716C10.5565 17.7084 10.742 17.7852 10.9354 17.7852C11.1288 17.7852 11.3143 17.7084 11.4511 17.5716C11.5879 17.4348 11.6647 17.2493 11.6647 17.0559C11.6647 16.8624 11.5879 16.6769 11.4511 16.5401C11.3143 16.4034 11.1288 16.3265 10.9354 16.3265C10.742 16.3265 10.5565 16.4034 10.4197 16.5401C10.2829 16.6769 10.2061 16.8624 10.2061 17.0559ZM10.2061 12.9989C10.2061 13.1923 10.2829 13.3778 10.4197 13.5146C10.5565 13.6514 10.742 13.7282 10.9354 13.7282C11.1288 13.7282 11.3143 13.6514 11.4511 13.5146C11.5879 13.3778 11.6647 13.1923 11.6647 12.9989C11.6647 12.8054 11.5879 12.6199 11.4511 12.4832C11.3143 12.3464 11.1288 12.2695 10.9354 12.2695C10.742 12.2695 10.5565 12.3464 10.4197 12.4832C10.2829 12.6199 10.2061 12.8054 10.2061 12.9989Z" fill="#9D9D9D"/>
                        <path d="M19.0348 8.41586C17.991 5.66031 15.3311 3.7002 12.2155 3.7002C9.09978 3.7002 6.43995 5.65803 5.39608 8.41359C3.43369 8.93096 1.98867 10.7247 2.00007 12.8535C2.01374 15.233 3.8599 17.168 6.18468 17.3754C6.2918 17.3845 6.38297 17.3002 6.38297 17.1931V15.8164C6.38297 15.7253 6.3146 15.6478 6.22343 15.6364C5.60804 15.5589 5.02685 15.2899 4.58012 14.8501C4.03312 14.3144 3.73226 13.5942 3.73226 12.8307C3.73226 12.1925 3.93967 11.5908 4.32941 11.0894C4.71004 10.6016 5.24565 10.2483 5.83596 10.0934L6.69978 9.86544L7.01659 9.02897C7.2126 8.50931 7.48611 8.02156 7.83027 7.58168C8.16987 7.14407 8.57329 6.76116 9.02457 6.44208C9.96132 5.78339 11.0645 5.43467 12.2155 5.43467C13.3664 5.43467 14.4696 5.78339 15.4063 6.44435C15.8599 6.76344 16.261 7.14635 16.6006 7.58396C16.9448 8.02384 17.2183 8.51159 17.4143 9.03125L17.7288 9.86544L18.5904 10.0934C19.8257 10.4216 20.6895 11.5452 20.6895 12.8284C20.6895 13.5942 20.3887 14.3122 19.8417 14.8478C19.3972 15.2854 18.8183 15.5566 18.2029 15.6341C18.1117 15.6455 18.0457 15.723 18.0457 15.8142V17.1931C18.0457 17.3002 18.1391 17.3845 18.2462 17.3754C20.5642 17.1657 22.4058 15.233 22.4217 12.858C22.4354 10.7293 20.9927 8.93552 19.0348 8.41586Z" fill="#9D9D9D"/>
                    </svg>
                    <svg v-else-if="shouldShowFilter(filter.name)" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5653_35804)">
                        <path d="M16.3657 4.5L19.2001 4.5024L19.2017 7.3208L14.8281 11.6936L17.0905 13.9568L18.2225 12.8256L19.3537 13.9568L17.3745 15.9368L19.6369 18.2L18.5057 19.3312L16.2425 17.068L14.2625 19.048L13.1313 17.9168L14.2625 16.7848L11.9993 14.5224L9.73688 16.7848L10.8689 17.9168L9.73768 19.048L7.75768 17.068L5.49448 19.3312L4.36328 18.2L6.62648 15.936L4.64648 13.9568L5.77768 12.8256L6.90888 13.956L9.17048 11.6936L4.80248 7.3256L4.80008 4.5L7.63688 4.5024L11.9993 8.8656L16.3657 4.5ZM10.3017 12.8248L8.04008 15.0872L8.60648 15.6528L10.8681 13.3904L10.3025 12.8248H10.3017ZM17.6009 6.1008H17.0273L13.1313 9.996L13.6961 10.5616L17.6009 6.6584V6.1008ZM6.40088 6.1008V6.6608L15.3937 15.6536L15.9593 15.088L6.97288 6.1016L6.40088 6.1008Z" fill="#9D9D9D"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_5653_35804">
                        <rect width="16" height="16" fill="white" transform="translate(4 3.7002)"/>
                        </clipPath>
                        </defs>
                    </svg>

                </div>
            </div>
            <button class="product-body__filters-btn" @click="showMobileFilters(true)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.9998 3.03333C20.2421 3.03333 20.4653 3.16511 20.5828 3.37708C20.7002 3.58894 20.6935 3.84741 20.5652 4.05286L15.6667 11.8907V20.7003C15.6666 20.9312 15.5468 21.1453 15.3503 21.2667C15.1538 21.3882 14.9086 21.3993 14.7019 21.296L8.7019 18.296C8.47619 18.1831 8.33386 17.9527 8.33374 17.7003V11.8907L3.43433 4.05286C3.30623 3.84751 3.29951 3.58883 3.41675 3.37708C3.53419 3.16518 3.7575 3.03342 3.99976 3.03333H19.9998Z" fill="#F6F6F6"/>
                </svg>
            </button>
            <div class="product-body__filters-modal" :class="{active: isShowMobileFilters}">
                <div class="product-body__filters-modal-head">
                    <span>{{ $t('Filters') }}</span>
                    <button @click="showMobileFilters(false)">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.041 3.36133C15.4129 2.98947 16.0158 2.98942 16.3877 3.36133C16.7594 3.73325 16.7595 4.33614 16.3877 4.70801L11.3467 9.74902L16.3877 14.79C16.7594 15.162 16.7595 15.7649 16.3877 16.1367C16.0159 16.5086 15.413 16.5084 15.041 16.1367L10 11.0957L4.95898 16.1367C4.58711 16.5085 3.98422 16.5084 3.6123 16.1367C3.2404 15.7648 3.24045 15.162 3.6123 14.79L8.65332 9.74902L3.6123 4.70801C3.24038 4.33608 3.24038 3.73326 3.6123 3.36133C3.98423 2.9894 4.58706 2.9894 4.95898 3.36133L10 8.40234L15.041 3.36133Z" fill="#C9C9C9"/>
                        </svg>
                    </button>
                </div>
                <div class="product-body__filters-modal-body" v-if="isOffersFiltersLoad">
                    <div class="product-body__filters-item" 
                        v-for="filter in filters.filters" 
                        :key="filter.name">
                        <CustomSelect
                            v-model="formData[filter.name]"
                            :options="productFilterSelect(filter.options)"
                            :selectId="filter.name"
                            :hasSearch="filter.name === 'filter[game_server]'"
                            @update:modelValue="changeFilters(filter.name)"
                        />
                        <div class="product-body__filters-item-img" :class="filter.name">
                            <svg v-if="filter.name === 'marketplace_id' || filter.name === 'platform_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                                <rect x="13.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                                <rect x="2.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                                <rect x="13.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                            </svg>
                            <svg v-else-if="filter.name === 'edition_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25C10.6923 2.24991 9.409 2.60349 8.28592 3.27329C7.16283 3.94309 6.24181 4.90418 5.62041 6.05475C4.999 7.20532 4.70035 8.50253 4.75608 9.809C4.81181 11.1155 5.21986 12.3825 5.93699 13.476L3.34999 17.956C3.27817 18.0808 3.24378 18.2236 3.25092 18.3673C3.25806 18.5111 3.30643 18.6498 3.39026 18.7669C3.47408 18.8839 3.58982 18.9743 3.72365 19.0274C3.85748 19.0804 4.00375 19.0938 4.14499 19.066L6.75899 18.552L7.61999 21.072C7.66639 21.2085 7.75117 21.3288 7.86416 21.4184C7.97716 21.5079 8.11359 21.5631 8.2571 21.5771C8.40061 21.5911 8.54513 21.5635 8.67334 21.4975C8.80155 21.4315 8.90802 21.33 8.97999 21.205L11.56 16.737C11.853 16.7555 12.1469 16.7555 12.44 16.737L15.02 21.205C15.092 21.3299 15.1986 21.4314 15.3269 21.4973C15.4551 21.5633 15.5997 21.5908 15.7432 21.5767C15.8867 21.5625 16.0231 21.5073 16.1361 21.4176C16.249 21.3279 16.3337 21.2076 16.38 21.071L17.238 18.545L19.854 19.065C19.9953 19.0931 20.1417 19.0798 20.2757 19.0269C20.4097 18.9739 20.5256 18.8835 20.6096 18.7664C20.6936 18.6494 20.742 18.5106 20.7492 18.3667C20.7563 18.2228 20.7219 18.0798 20.65 17.955L18.064 13.476C18.7812 12.3825 19.1892 11.1153 19.2449 9.80875C19.3006 8.5022 19.0019 7.20491 18.3803 6.05431C17.7588 4.90371 16.8376 3.94264 15.7144 3.27291C14.5912 2.60318 13.3077 2.24973 12 2.25ZM6.24999 9.5C6.24999 7.97501 6.85579 6.51247 7.93413 5.43414C9.01246 4.3558 10.475 3.75 12 3.75C13.525 3.75 14.9875 4.3558 16.0659 5.43414C17.1442 6.51247 17.75 7.97501 17.75 9.5C17.75 11.025 17.1442 12.4875 16.0659 13.5659C14.9875 14.6442 13.525 15.25 12 15.25C10.475 15.25 9.01246 14.6442 7.93413 13.5659C6.85579 12.4875 6.24999 11.025 6.24999 9.5ZM9.98399 16.466C8.84648 16.1367 7.80711 15.5334 6.95699 14.709L5.47499 17.276L7.11199 16.954C7.28988 16.9191 7.4744 16.9498 7.6314 17.0404C7.7884 17.1311 7.90726 17.2755 7.96599 17.447L8.50599 19.026L9.98399 16.466ZM15.492 19.022L14.016 16.466C15.1535 16.1367 16.1929 15.5334 17.043 14.709L18.523 17.272L16.885 16.946C16.7065 16.9107 16.5213 16.9414 16.3639 17.0325C16.2064 17.1235 16.0874 17.2687 16.029 17.441L15.492 19.022Z" fill="#9D9D9D"/>
                            </svg>
                            <svg v-else-if="filter.name === 'region' || filter.name === 'region_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.5598 20.82C12.3963 20.9366 12.2006 20.9993 11.9998 20.9993C11.799 20.9993 11.6032 20.9366 11.4398 20.82C6.61078 17.378 1.48578 10.298 6.66678 5.182C8.08864 3.78212 10.0044 2.99826 11.9998 3C13.9998 3 15.9188 3.785 17.3328 5.181C22.5138 10.297 17.3888 17.376 12.5598 20.82Z" stroke="#9D9D9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 12C12.5304 12 13.0391 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 10C14 9.46957 13.7893 8.96086 13.4142 8.58579C13.0391 8.21071 12.5304 8 12 8C11.4696 8 10.9609 8.21071 10.5858 8.58579C10.2107 8.96086 10 9.46957 10 10C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12Z" stroke="#9D9D9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <svg v-else-if="filter.name === 'filter[game_server]'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5878 10.1729H7.83566C7.73537 10.1729 7.65332 10.2549 7.65332 10.3552V19.5176C7.65332 19.6179 7.73537 19.6999 7.83566 19.6999H16.5878C16.6881 19.6999 16.7701 19.6179 16.7701 19.5176V10.3552C16.7701 10.2549 16.6881 10.1729 16.5878 10.1729ZM9.11201 11.6315H15.3114V14.2982H9.11201V11.6315ZM15.3114 18.2412H9.11201V15.5746H15.3114V18.2412Z" fill="#9D9D9D"/>
                                <path d="M10.2061 17.0559C10.2061 17.2493 10.2829 17.4348 10.4197 17.5716C10.5565 17.7084 10.742 17.7852 10.9354 17.7852C11.1288 17.7852 11.3143 17.7084 11.4511 17.5716C11.5879 17.4348 11.6647 17.2493 11.6647 17.0559C11.6647 16.8624 11.5879 16.6769 11.4511 16.5401C11.3143 16.4034 11.1288 16.3265 10.9354 16.3265C10.742 16.3265 10.5565 16.4034 10.4197 16.5401C10.2829 16.6769 10.2061 16.8624 10.2061 17.0559ZM10.2061 12.9989C10.2061 13.1923 10.2829 13.3778 10.4197 13.5146C10.5565 13.6514 10.742 13.7282 10.9354 13.7282C11.1288 13.7282 11.3143 13.6514 11.4511 13.5146C11.5879 13.3778 11.6647 13.1923 11.6647 12.9989C11.6647 12.8054 11.5879 12.6199 11.4511 12.4832C11.3143 12.3464 11.1288 12.2695 10.9354 12.2695C10.742 12.2695 10.5565 12.3464 10.4197 12.4832C10.2829 12.6199 10.2061 12.8054 10.2061 12.9989Z" fill="#9D9D9D"/>
                                <path d="M19.0348 8.41586C17.991 5.66031 15.3311 3.7002 12.2155 3.7002C9.09978 3.7002 6.43995 5.65803 5.39608 8.41359C3.43369 8.93096 1.98867 10.7247 2.00007 12.8535C2.01374 15.233 3.8599 17.168 6.18468 17.3754C6.2918 17.3845 6.38297 17.3002 6.38297 17.1931V15.8164C6.38297 15.7253 6.3146 15.6478 6.22343 15.6364C5.60804 15.5589 5.02685 15.2899 4.58012 14.8501C4.03312 14.3144 3.73226 13.5942 3.73226 12.8307C3.73226 12.1925 3.93967 11.5908 4.32941 11.0894C4.71004 10.6016 5.24565 10.2483 5.83596 10.0934L6.69978 9.86544L7.01659 9.02897C7.2126 8.50931 7.48611 8.02156 7.83027 7.58168C8.16987 7.14407 8.57329 6.76116 9.02457 6.44208C9.96132 5.78339 11.0645 5.43467 12.2155 5.43467C13.3664 5.43467 14.4696 5.78339 15.4063 6.44435C15.8599 6.76344 16.261 7.14635 16.6006 7.58396C16.9448 8.02384 17.2183 8.51159 17.4143 9.03125L17.7288 9.86544L18.5904 10.0934C19.8257 10.4216 20.6895 11.5452 20.6895 12.8284C20.6895 13.5942 20.3887 14.3122 19.8417 14.8478C19.3972 15.2854 18.8183 15.5566 18.2029 15.6341C18.1117 15.6455 18.0457 15.723 18.0457 15.8142V17.1931C18.0457 17.3002 18.1391 17.3845 18.2462 17.3754C20.5642 17.1657 22.4058 15.233 22.4217 12.858C22.4354 10.7293 20.9927 8.93552 19.0348 8.41586Z" fill="#9D9D9D"/>
                            </svg>
                            <svg v-else-if="filter.name === 'filter[game_fraction]'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_5653_35804)">
                                <path d="M16.3657 4.5L19.2001 4.5024L19.2017 7.3208L14.8281 11.6936L17.0905 13.9568L18.2225 12.8256L19.3537 13.9568L17.3745 15.9368L19.6369 18.2L18.5057 19.3312L16.2425 17.068L14.2625 19.048L13.1313 17.9168L14.2625 16.7848L11.9993 14.5224L9.73688 16.7848L10.8689 17.9168L9.73768 19.048L7.75768 17.068L5.49448 19.3312L4.36328 18.2L6.62648 15.936L4.64648 13.9568L5.77768 12.8256L6.90888 13.956L9.17048 11.6936L4.80248 7.3256L4.80008 4.5L7.63688 4.5024L11.9993 8.8656L16.3657 4.5ZM10.3017 12.8248L8.04008 15.0872L8.60648 15.6528L10.8681 13.3904L10.3025 12.8248H10.3017ZM17.6009 6.1008H17.0273L13.1313 9.996L13.6961 10.5616L17.6009 6.6584V6.1008ZM6.40088 6.1008V6.6608L15.3937 15.6536L15.9593 15.088L6.97288 6.1016L6.40088 6.1008Z" fill="#9D9D9D"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_5653_35804">
                                <rect width="16" height="16" fill="white" transform="translate(4 3.7002)"/>
                                </clipPath>
                                </defs>
                            </svg>

                        </div>
                    </div>
                    <div class="product-body__filters-item" v-if="filters?.sort?.list">
                        <CheckboxSelect :title="$t('Sort by')" :inputs="filters.sort.list" @changed="changeFilters" />

                    </div>
                </div>
                <div class="product-body__filters-modal-btns">
                    <button class="btn" @click="showMobileFilters(false)">
                        <span>{{ $t('Apply filters') }}</span>
                    </button>
                    <button class="btn clear" @click="changeFilters('clear')">
                        <span>{{ $t('Clear filters') }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="product-body__filters" v-else ref="filtersRef" :class="{
                'items-4': activeFiltersCount === 4,
                'items-3': activeFiltersCount === 3,
                'items-2': activeFiltersCount === 2,
            }">
            <template v-if="isOffersFiltersLoad">
                <div class="product-body__filters-item" 
                    v-for="filter in filters.filters" 
                    :key="filter.name">
                    <CustomSelect
                        v-model="formData[filter.name]"
                        :options="productFilterSelect(filter.options)"
                        :selectId="filter.name"
                        :hasSearch="filter.name === 'filter[game_server]'"
                        @update:modelValue="changeFilters(filter.name)"
                    />
                    <div class="product-body__filters-item-img" :class="filter.name">
                        <svg v-if="filter.name === 'marketplace_id' || filter.name === 'platform_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                            <rect x="13.7" y="2.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                            <rect x="2.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                            <rect x="13.7" y="13.7" width="7.6" height="7.6" rx="1.3" stroke="#9D9D9D" stroke-width="1.4"/>
                        </svg>
                        <svg v-else-if="filter.name === 'edition_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25C10.6923 2.24991 9.409 2.60349 8.28592 3.27329C7.16283 3.94309 6.24181 4.90418 5.62041 6.05475C4.999 7.20532 4.70035 8.50253 4.75608 9.809C4.81181 11.1155 5.21986 12.3825 5.93699 13.476L3.34999 17.956C3.27817 18.0808 3.24378 18.2236 3.25092 18.3673C3.25806 18.5111 3.30643 18.6498 3.39026 18.7669C3.47408 18.8839 3.58982 18.9743 3.72365 19.0274C3.85748 19.0804 4.00375 19.0938 4.14499 19.066L6.75899 18.552L7.61999 21.072C7.66639 21.2085 7.75117 21.3288 7.86416 21.4184C7.97716 21.5079 8.11359 21.5631 8.2571 21.5771C8.40061 21.5911 8.54513 21.5635 8.67334 21.4975C8.80155 21.4315 8.90802 21.33 8.97999 21.205L11.56 16.737C11.853 16.7555 12.1469 16.7555 12.44 16.737L15.02 21.205C15.092 21.3299 15.1986 21.4314 15.3269 21.4973C15.4551 21.5633 15.5997 21.5908 15.7432 21.5767C15.8867 21.5625 16.0231 21.5073 16.1361 21.4176C16.249 21.3279 16.3337 21.2076 16.38 21.071L17.238 18.545L19.854 19.065C19.9953 19.0931 20.1417 19.0798 20.2757 19.0269C20.4097 18.9739 20.5256 18.8835 20.6096 18.7664C20.6936 18.6494 20.742 18.5106 20.7492 18.3667C20.7563 18.2228 20.7219 18.0798 20.65 17.955L18.064 13.476C18.7812 12.3825 19.1892 11.1153 19.2449 9.80875C19.3006 8.5022 19.0019 7.20491 18.3803 6.05431C17.7588 4.90371 16.8376 3.94264 15.7144 3.27291C14.5912 2.60318 13.3077 2.24973 12 2.25ZM6.24999 9.5C6.24999 7.97501 6.85579 6.51247 7.93413 5.43414C9.01246 4.3558 10.475 3.75 12 3.75C13.525 3.75 14.9875 4.3558 16.0659 5.43414C17.1442 6.51247 17.75 7.97501 17.75 9.5C17.75 11.025 17.1442 12.4875 16.0659 13.5659C14.9875 14.6442 13.525 15.25 12 15.25C10.475 15.25 9.01246 14.6442 7.93413 13.5659C6.85579 12.4875 6.24999 11.025 6.24999 9.5ZM9.98399 16.466C8.84648 16.1367 7.80711 15.5334 6.95699 14.709L5.47499 17.276L7.11199 16.954C7.28988 16.9191 7.4744 16.9498 7.6314 17.0404C7.7884 17.1311 7.90726 17.2755 7.96599 17.447L8.50599 19.026L9.98399 16.466ZM15.492 19.022L14.016 16.466C15.1535 16.1367 16.1929 15.5334 17.043 14.709L18.523 17.272L16.885 16.946C16.7065 16.9107 16.5213 16.9414 16.3639 17.0325C16.2064 17.1235 16.0874 17.2687 16.029 17.441L15.492 19.022Z" fill="#9D9D9D"/>
                        </svg>
                        <svg v-else-if="filter.name === 'region' || filter.name === 'region_id'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5598 20.82C12.3963 20.9366 12.2006 20.9993 11.9998 20.9993C11.799 20.9993 11.6032 20.9366 11.4398 20.82C6.61078 17.378 1.48578 10.298 6.66678 5.182C8.08864 3.78212 10.0044 2.99826 11.9998 3C13.9998 3 15.9188 3.785 17.3328 5.181C22.5138 10.297 17.3888 17.376 12.5598 20.82Z" stroke="#9D9D9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 12C12.5304 12 13.0391 11.7893 13.4142 11.4142C13.7893 11.0391 14 10.5304 14 10C14 9.46957 13.7893 8.96086 13.4142 8.58579C13.0391 8.21071 12.5304 8 12 8C11.4696 8 10.9609 8.21071 10.5858 8.58579C10.2107 8.96086 10 9.46957 10 10C10 10.5304 10.2107 11.0391 10.5858 11.4142C10.9609 11.7893 11.4696 12 12 12Z" stroke="#9D9D9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg v-else-if="filter.name === 'filter[game_server]'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.5878 10.1729H7.83566C7.73537 10.1729 7.65332 10.2549 7.65332 10.3552V19.5176C7.65332 19.6179 7.73537 19.6999 7.83566 19.6999H16.5878C16.6881 19.6999 16.7701 19.6179 16.7701 19.5176V10.3552C16.7701 10.2549 16.6881 10.1729 16.5878 10.1729ZM9.11201 11.6315H15.3114V14.2982H9.11201V11.6315ZM15.3114 18.2412H9.11201V15.5746H15.3114V18.2412Z" fill="#9D9D9D"/>
                            <path d="M10.2061 17.0559C10.2061 17.2493 10.2829 17.4348 10.4197 17.5716C10.5565 17.7084 10.742 17.7852 10.9354 17.7852C11.1288 17.7852 11.3143 17.7084 11.4511 17.5716C11.5879 17.4348 11.6647 17.2493 11.6647 17.0559C11.6647 16.8624 11.5879 16.6769 11.4511 16.5401C11.3143 16.4034 11.1288 16.3265 10.9354 16.3265C10.742 16.3265 10.5565 16.4034 10.4197 16.5401C10.2829 16.6769 10.2061 16.8624 10.2061 17.0559ZM10.2061 12.9989C10.2061 13.1923 10.2829 13.3778 10.4197 13.5146C10.5565 13.6514 10.742 13.7282 10.9354 13.7282C11.1288 13.7282 11.3143 13.6514 11.4511 13.5146C11.5879 13.3778 11.6647 13.1923 11.6647 12.9989C11.6647 12.8054 11.5879 12.6199 11.4511 12.4832C11.3143 12.3464 11.1288 12.2695 10.9354 12.2695C10.742 12.2695 10.5565 12.3464 10.4197 12.4832C10.2829 12.6199 10.2061 12.8054 10.2061 12.9989Z" fill="#9D9D9D"/>
                            <path d="M19.0348 8.41586C17.991 5.66031 15.3311 3.7002 12.2155 3.7002C9.09978 3.7002 6.43995 5.65803 5.39608 8.41359C3.43369 8.93096 1.98867 10.7247 2.00007 12.8535C2.01374 15.233 3.8599 17.168 6.18468 17.3754C6.2918 17.3845 6.38297 17.3002 6.38297 17.1931V15.8164C6.38297 15.7253 6.3146 15.6478 6.22343 15.6364C5.60804 15.5589 5.02685 15.2899 4.58012 14.8501C4.03312 14.3144 3.73226 13.5942 3.73226 12.8307C3.73226 12.1925 3.93967 11.5908 4.32941 11.0894C4.71004 10.6016 5.24565 10.2483 5.83596 10.0934L6.69978 9.86544L7.01659 9.02897C7.2126 8.50931 7.48611 8.02156 7.83027 7.58168C8.16987 7.14407 8.57329 6.76116 9.02457 6.44208C9.96132 5.78339 11.0645 5.43467 12.2155 5.43467C13.3664 5.43467 14.4696 5.78339 15.4063 6.44435C15.8599 6.76344 16.261 7.14635 16.6006 7.58396C16.9448 8.02384 17.2183 8.51159 17.4143 9.03125L17.7288 9.86544L18.5904 10.0934C19.8257 10.4216 20.6895 11.5452 20.6895 12.8284C20.6895 13.5942 20.3887 14.3122 19.8417 14.8478C19.3972 15.2854 18.8183 15.5566 18.2029 15.6341C18.1117 15.6455 18.0457 15.723 18.0457 15.8142V17.1931C18.0457 17.3002 18.1391 17.3845 18.2462 17.3754C20.5642 17.1657 22.4058 15.233 22.4217 12.858C22.4354 10.7293 20.9927 8.93552 19.0348 8.41586Z" fill="#9D9D9D"/>
                        </svg>
                        <svg v-else-if="filter.name === 'filter[game_fraction]'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_5653_35804)">
                            <path d="M16.3657 4.5L19.2001 4.5024L19.2017 7.3208L14.8281 11.6936L17.0905 13.9568L18.2225 12.8256L19.3537 13.9568L17.3745 15.9368L19.6369 18.2L18.5057 19.3312L16.2425 17.068L14.2625 19.048L13.1313 17.9168L14.2625 16.7848L11.9993 14.5224L9.73688 16.7848L10.8689 17.9168L9.73768 19.048L7.75768 17.068L5.49448 19.3312L4.36328 18.2L6.62648 15.936L4.64648 13.9568L5.77768 12.8256L6.90888 13.956L9.17048 11.6936L4.80248 7.3256L4.80008 4.5L7.63688 4.5024L11.9993 8.8656L16.3657 4.5ZM10.3017 12.8248L8.04008 15.0872L8.60648 15.6528L10.8681 13.3904L10.3025 12.8248H10.3017ZM17.6009 6.1008H17.0273L13.1313 9.996L13.6961 10.5616L17.6009 6.6584V6.1008ZM6.40088 6.1008V6.6608L15.3937 15.6536L15.9593 15.088L6.97288 6.1016L6.40088 6.1008Z" fill="#9D9D9D"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_5653_35804">
                            <rect width="16" height="16" fill="white" transform="translate(4 3.7002)"/>
                            </clipPath>
                            </defs>
                        </svg>

                    </div>
                </div>
                <div class="product-body__filters-item" v-if="filters?.sort?.list">
                    <CheckboxSelect :title="$t('Sort by')" :inputs="filters.sort.list" @changed="changeFilters" />

                </div>
            </template>
            <template v-else>
                <div class="product-body__filters-item placeholder"></div>
                <div class="product-body__filters-item placeholder"></div>
                <div class="product-body__filters-item placeholder"></div>
                <div class="product-body__filters-item placeholder"></div>
            </template>
        </div>
        <div class="product-body__badge" v-if="product?.badge && mobile" :class="product?.badge === 2 ? 'dlc' : ''">
            <div class="product-body__badge-icon">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.25 12C8.25 11.5858 8.58579 11.25 9 11.25C9.41421 11.25 9.75 11.5858 9.75 12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12ZM8.25 6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V6ZM9 1.5C4.8525 1.5 1.5 4.875 1.5 9C1.5 10.9891 2.29018 12.8968 3.6967 14.3033C4.39314 14.9997 5.21993 15.5522 6.12987 15.9291C7.03982 16.306 8.01509 16.5 9 16.5C10.9891 16.5 12.8968 15.7098 14.3033 14.3033C15.7098 12.8968 16.5 10.9891 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98491 1.5 9 1.5ZM9 15C7.4087 15 5.88258 14.3679 4.75736 13.2426C3.63214 12.1174 3 10.5913 3 9C3 7.4087 3.63214 5.88258 4.75736 4.75736C5.88258 3.63214 7.4087 3 9 3C10.5913 3 12.1174 3.63214 13.2426 4.75736C14.3679 5.88258 15 7.4087 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z" fill="#FFC700"/>
                </svg>
            </div>
            <span class="product-body__badge-text" v-html="product?.badge === 2 ? 
                $t('This product is an {dlc} to the main game, you can use it if you have the game itself.', {ns: 'product', dlc: '<span>'+ $t('Add-on', {ns: 'product'}) +'</span>'}) : 
                $t('This game is in {preorder} and will be available for Download/Installation on the day of release.', {ns: 'product', preorder: '<span>'+ $t('pre-order status', {ns: 'product'}) +'</span>'})">
            </span>
        </div>
        <div class="product-body__offers">
            <div class="product-body__offers-container" v-if="productOffersRecomended.length">
                <div class="product-body__offers-title recommended">
                    <h4>{{ $t('Recommended offers') }}</h4>
                    <span></span>
                </div>
                <div class="product-body__offers-wrap recommended" v-if="isProductOffersLoad">
                    <CatalogOffer 
                        v-for="offer in productOffersRecomended" 
                        :key="offer.id"
                        :bigDesktop="bigDesktop"
                        :mobile="mobile"
                        :offer="offer"
                        :tablet="tablet"
                        :tabletMax="tabletMax"
                        :isOnlineGame="isOnlineGame"
                        :isRecommended="true"
                        :activeOfferTooltipId="activeOfferTooltipId"
                        @update:bookmark="updateBookmarkStatus"
                        @tooltip-id-active="setActiveTooltipId"
                        @update-cart="forwardUpdateCart"/>
                </div>
                <div class="product-body__offers-wrap recommended" v-else>
                    <CatalogOffer 
                        v-for="offer in 3" 
                        :key="offer" 
                        :offer="{id: null}" 
                        :isRecommended="true"
                        :bigDesktop="bigDesktop"
                        :mobile="mobile"
                        :tablet="tablet"
                        :tabletMax="tabletMax"
                        :isOnlineGame="isOnlineGame"/>
                </div>
            </div>
            <div class="product-body__offers-container" v-if="productOffers.length !== 0">
                <div class="product-body__offers-title" v-if="productOffersRecomended.length">
                    <h4>{{ $t('Other offers') }}</h4>
                    <span></span>
                </div>
                <div class="product-body__offers-wrap" v-if="isProductOffersLoad">
                    <CatalogOffer 
                        v-for="offer in productOffers" 
                        :key="offer.id" 
                        :offer="offer"
                        :bigDesktop="bigDesktop"
                        :mobile="mobile"
                        :tablet="tablet"
                        :tabletMax="tabletMax"
                        :isOnlineGame="isOnlineGame"
                        :isRecommended="false"
                        :activeOfferTooltipId="activeOfferTooltipId"
                        @update:bookmark="updateBookmarkStatus"
                        @tooltip-id-active="setActiveTooltipId"
                        @update-cart="forwardUpdateCart"/>
                </div>
                <div class="product-body__offers-wrap" v-else>
                    <CatalogOffer 
                        v-for="offer in 10" 
                        :key="offer" 
                        :offer="{id: null}" 
                        :isRecommended="false"
                        :bigDesktop="bigDesktop"
                        :mobile="mobile"
                        :tablet="tablet"
                        :tabletMax="tabletMax"
                        :isOnlineGame="isOnlineGame"/>
                </div>
            </div>
            <Pagination v-if="offersMeta?.total_count && offersMeta.total_count > 15"
                :currentPage="offersMeta.current_page"
                :totalPages="offersMeta.page_count"
                :totalCount="offersMeta.total_count"
                :isLoadMoreBtn="true"
                :mobile="mobile"
                :loadedPages="loadedPages"
                :maxPageItems="mobile ? 4 : 9"
                :perPage="10"
                @update-page="paginationFun"/>
        </div>
    </div>
</template>

<script>
import CatalogOffer from './CatalogOffer.vue';
import Pagination from '../../../../components/Pagination.vue';
import CustomSelect from '../../../../components/CustomSelect.vue';
import CheckboxSelect from '../../../../components/CheckboxSelect.vue';
import scrollLock from 'scroll-lock';
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
  components: {
    CatalogOffer,
    Pagination,
    CustomSelect,
    CheckboxSelect
  },
  emits: ['update-cart', 'update:bookmark', 'update-filters', 'update-page', 'update:platform-tab-id'],
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    tablet: {
      type: Boolean,
      default: false
    },
    tabletMax: {
      type: Boolean,
      default: false
    },
    bigDesktop: {
      type: Boolean,
      default: false
    },
    isOnlineGame: {
      type: Boolean,
      default: false
    },
    isProductOffersLoad: {
      type: Boolean,
      default: false
    },
    isOffersFiltersLoad: {
      type: Boolean,
      default: false
    },
    isUpdatePaginations: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    tabsArray: {
      type: Array,
      default: () => []
    },
    offersMeta: {
      type: Object,
      default: () => ({})
    },
    productOffers: {
      type: Array,
      default: () => [{id: null}]
    },
    productOffersRecomended: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
        formData: {},
        loadedPages: [],
        isShowMobileFilters: false,
        activeOfferTooltipId: null,
        activeFiltersCount: null,
        activePlatformTabId: window.settings.product.id,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleGlobalClick);
  },
  watch: {
    isUpdatePaginations(val) {
        if(val) {
            this.loadedPages = [this.offersMeta.current_page];
        }
    },
    filters: {
        handler(newFilters) {
            if (!newFilters.filters) return;
            let activeFiltersCount = 0;

            Object.values(newFilters.filters).forEach(filter => {
                if (!filter.options) return;
                const selected = filter.options.find(o => o.selected);

                this.formData[filter.name] = selected
                    ? selected.value
                    : filter.options[0]?.value ?? null;

                if (selected) {
                    activeFiltersCount++;
                }
            });

            if (newFilters.sort?.list) {
                activeFiltersCount++;
                Object.values(newFilters.sort.list).forEach(sort => {
                    this.formData[sort.name] = sort.selected ? 1 : 0;
                });
            }
            this.activeFiltersCount = activeFiltersCount;
        },
        deep: true,
        immediate: true
    }
  },
  methods: {
    decodeHtmlEntities,
    showMobileFilters(bool) {
        this.isShowMobileFilters = bool
        if (bool) {
            scrollLock.disablePageScroll(document.body);
            document.body.classList.add('modal-open-vue');
        } else {
            scrollLock.enablePageScroll(document.body);
            document.body.classList.remove('modal-open-vue');
        }

    },
    shouldShowFilter(name) {
        const isServer = name === 'filter[game_server]';
        const isFraction = name === 'filter[game_fraction]';

        if (!isServer && !isFraction) return true;

        if (this.mobile) {
            return isServer;
        }

        if (this.tablet) {
            return true;
        }
        return true;
    },
    getLimitedFilters(list) {
        if (!Array.isArray(list)) return [];

        if (this.mobile) return list.slice(0, 1);
        if (this.tablet) return list.slice(0, 2);
        return list;
    },
    productTabSelect() {
        return this.tabsArray.map(tab => ({
            value: tab.product_id,
            text: tab.name,
            icon:
                tab.platform_id === 4
                ? '/img/icons/platforms/pc-gray.svg'
                : tab.platform_id === 7 || tab.platform_id === 2
                ? '/img/icons/platforms/playstation-gray.svg'
                : tab.platform_id === 8 || tab.platform_id === 3
                ? '/img/icons/platforms/xbox-gray.svg'
                : tab.platform_id === 6
                ? '/img/icons/platforms/nintendo-gray.svg'
                : tab.platform_id === 16
                ? '/img/icons/platforms/mobile.svg'
                : '/img/icons/platforms/pc-gray.svg',
        }));
    },
    productFilterSelect(options) {
        return options.map(item => ({
            value: item.value,
            text: item.option
        }));
    },
    changeFilters(fieldName = '') {
        if(fieldName === 'clear') {
            this.showMobileFilters(false)
            Object.keys(this.formData).forEach(key => {
                this.formData[key] = '';
            });
        }
        this.$emit('update-filters', this.formData);
    },
    changeTab() {
        this.$emit('update:platform-tab-id', this.activePlatformTabId);
    },
    forwardUpdateCart(payload) {
        this.$emit('update-cart', payload);
    },
    paginationFun({page, showMore}) {
        this.$emit('update-page', {page, showMore});
        if(!showMore) {
            const block = this.$refs.filtersRef;
            block?.scrollIntoView({ behavior: 'smooth' });
        }
    },
    updateBookmarkStatus(payload) {
        this.$emit('update:bookmark', payload);
    },
    setActiveTooltipId(id) {
      this.activeOfferTooltipId = id;
    },
    handleGlobalClick(e) {
        const insideTooltip = e.target.closest('.offer-body__tooltip.show');
        if (insideTooltip && this.activeOfferTooltipId) return;
        
        this.activeOfferTooltipId = null;
    }
  },

};
</script>
  
<style lang="scss">
.product-body__filters-item{
    .custom-select-wrap-vue.active + .product-body__filters-item-img {
        &.filter\[game_fraction\],
        &.filter\[game_server\],
        &.edition_id{
            svg{
                path{
                    fill: #4e8aff;
                }
            }
        }
        &.region,
        &.region_id{
            svg{
                path{
                    stroke: #4e8aff;
                }
            }
        }
        &.marketplace_id,
        &.platform_id{
            svg{
                rect{
                    stroke: #4e8aff;
                }
            }
        }
    }
    .custom-select-wrap-vue {
        .sub-value__label{
            max-width: calc(100% - 90px) !important;
            width: 100%;
            min-width: 100%;
            -webkit-mask-image: linear-gradient(90deg, #fff 90%, transparent);
        }
        .fake-select-vue.has-search{
            .sub-value__label{
                max-width: auto !important;
                width: auto;
                min-width: 0;
                -webkit-mask-image: none;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
    .product-body{
        padding-bottom: 50px;
        &__title{
            padding: 16px 16px 0;
            margin: 0 -15px;
            background-color: #fff;
            h4{
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #505050;
                padding-bottom: 16px;
                width: 100%;
                border-bottom: 1px solid #E5E5E5;
            }
        }
        &__filters{
            background-color: #FFFFFF;
            border-radius: 16px;
            padding: 20px;
            margin-bottom: 20px;
            display: flex;
            gap: 20px;
            @media only screen and (max-width: 767px) {
                border-radius: 0;
                padding: 16px;
                margin: 0 -15px 20px -15px;
            }
            &-btn{
                width: 54px;
                height: 56px;
                min-width: 54px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #4E8AFF;
                border-radius: 8px;
            }
            &-modal{
                height: calc(100% - 44px);
                left: 0;
                padding: 20px 15px 150px;
                pointer-events: none;
                position: fixed;
                top: 44px;
                background-color: #fff;
                -webkit-transform: translateX(100%);
                transform: translateX(100%);
                -webkit-transition: .5s;
                transition: .5s;
                width: 100%;
                z-index: 1020;
                &.active{
                    overflow-y: auto;
                    pointer-events: visible;
                    -webkit-transform: translateX(0);
                    transform: translateX(0);
                }
                &-head{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 10px 0 30px;
                    span{
                        color: #f6f6f6;
                        font-family: "Avenir-Next-DemiBold", sans-serif;
                        font-size: 22px;
                        font-weight: 100;
                        line-height: 140%;
                        color: #505050;
                    }
                }
                &-body{
                    .product-body__filters-item{
                        margin-bottom: 15px;
                    }
                }
                &-btns{
                    background-color: #fff;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    box-shadow: 0 -5px 15px 0 rgba(0, 0, 0, .2);
                    border-radius: 8px 8px 0 0;
                    display: flex;
                    flex-direction: column;
                    padding: 15px;
                    gap: 15px;
                    width: 100%;
                    z-index: 10;
                    .btn{
                        width: 100%;
                        height: 44px !important;
                        border-radius: 8px;
                        background-color: #fff;
                        border: 1px solid #F75A01;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        transition: 0.4s;
                        @media only screen and (max-width: 1919px) {
                            height: 46px;
                        }
                        @media only screen and (max-width: 991px) {
                            height: 20px;
                        }
                        span{
                            font-family: "Avenir-Next-DemiBold", sans-serif;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 140%;
                            letter-spacing: 0px;
                            text-align: center;
                            color: #F75A01;
                            transition: 0.4s;
                        }
                        &.clear{
                            background-color: #F75A01;
                            span{
                                color: #fff;
                            }
                        }
                    }
                }
            }
            &-item{
                position: relative;
                width: 100%;
                :deep(.fake-select-vue) {
                    padding-left: 45px;
                }
                &.tabs{
                    :deep(.fake-select-vue) {
                        padding-left: 15px;
                    }
                }
                &.placeholder{
                    height: 56px;
                    border-radius: 8px;
                }
                &-img{
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    left: 15px;
                    top: 15px;
                    z-index: 2;
                    svg{
                        rect,
                        path{
                            transition: 0.4s;
                        }
                    }
                }
                .fake-select-vue{
                    &::before{
                        content: '';
                        position: absolute;
                        left: 0;
                    }
                }
            }
            &.items-4{
                .product-body__filters-item{
                    max-width: 25%;
                }
            }
            &.items-3{
                .product-body__filters-item{
                    max-width: 33.3%;
                }
            }
            &.items-2{
                .product-body__filters-item{
                    max-width: 50%;
                }
            }
        }
        &__badge{
            box-shadow: 3px 3px 12px 0px #0000000D;
            box-shadow: -2px -2px 8px 0px #0000000D;
            padding: 10px 15px;
            display: flex;
            align-items: flex-start;
            gap: 15px;
            background-color: #fff;
            border-radius: 12px;
            margin: 0 0 20px;
            background-image: url('/webpack-assets/img/product/badge-pre-order.png');
            background-size: 100% 100%;
            background-position: left;
            background-repeat: no-repeat;
            &-icon{
                box-shadow: 0px 1.5px 11.25px 0px #F0BB014D;
                border-radius: 50%;
                width: 24px;
                height: 24px;
                min-width: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            &-text{
                font-family: "Avenir-Next";
                color: #505050;
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                &:deep(span){
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    color: #FFC700;
                }
            }
            &.dlc{
                background-image: url('/webpack-assets/img/product/badge-dlc.png');
                .product-body__badge-icon{
                    box-shadow: 0px 1.5px 11.25px 0px #017CF04D;
                    svg{
                        path{
                            fill: #4E8AFF;
                        }
                    }
                }
                .product-body__badge-text{
                    color: #505050;
                    &:deep(span){
                        color: #4E8AFF;
                    }
                }
            }
        }
        &__offers{
            &-container{
                margin-bottom: 20px;
            }
            &-title{
                margin-bottom: 10px;
                display: flex;
                gap: 15px;
                align-items: center;
                flex-wrap: nowrap;
                &.recommended{
                   h4{
                        color: #4E8AFF;
                   }
                   span{
                        background: #4E8AFF33;
                   } 
                }
                h4{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    text-align: left;
                    color: #9D9D9D;
                    white-space: nowrap;
                }
                span{
                    height: 1px;
                    width: 100%;
                    background: #1F1F1F33;
                }
            }
            &-wrap{
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }
</style>